<template>
    <div
        v-if="variant === 'compact'"
        class="mb-4 border-b border-gray-200 dark:border-gray-700"
    >
        <nav class="-mb-px flex gap-1 overflow-x-auto px-1 py-1.5">
            <router-link
                v-for="tab in tabs"
                :key="tab.route"
                :to="
                    tab.hasOwnProperty('params')
                        ? { name: tab.route, params: tab.params }
                        : { name: tab.route }
                "
                class="whitespace-nowrap rounded-md px-3 py-1.5 text-xs font-medium text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300"
                v-bind="activeClass"
            >
                {{ tab.label }}
            </router-link>
        </nav>
    </div>
    <div
        v-else
        class="text-center text-sm font-medium text-gray-500 dark:text-gray-400"
    >
        <ul class="-mb-px flex flex-wrap">
            <li class="mr-2" v-for="tab in tabs" :key="tab.route">
                <router-link
                    :to="
                        tab.hasOwnProperty('params')
                            ? { name: tab.route, params: tab.params }
                            : { name: tab.route }
                    "
                    class="border-3 inline-block rounded-t-lg border-b-2 border-transparent p-4"
                    v-bind="activeClass"
                >
                    {{ tab.label }}
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        exact: {
            type: Boolean,
            default: true,
        },
        tabs: {
            type: Array,
            required: true,
        },
        variant: {
            type: String,
            default: "default",
        },
    },

    computed: {
        activeClass() {
            if (this.variant === "compact") {
                const classString =
                    "bg-gray-900 !text-white dark:bg-white dark:!text-gray-900";
                return this.exact
                    ? { "exact-active-class": classString }
                    : { "active-class": classString };
            }

            const classString =
                "font-bold text-indigo-500 border-indigo-500 dark:border-indigo-500";
            return this.exact
                ? { "exact-active-class": classString }
                : { "active-class": classString };
        },
    },
};
</script>
